import React from "react";
import { Box, Grid, Typography, Button } from "@material-ui/core";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import ArrowBackIosRoundedIcon from "@material-ui/icons/ArrowBackIosRounded";
import StyledBox from "../../../../components/StyledBox";
import OtpInput from "../../OtpInput";
import { useStyles } from "../../index";

/**
 * OtpVerificationStage Component
 * 
 * Handles the OTP verification step of the registration form.
 * Includes OTP input, submit, and resend functionality.
 * 
 * Separation of Concerns:
 * - Only handles UI rendering for OTP verification
 * - Receives all data and callbacks via props
 * - Contains its own Formik form for OTP validation
 */
const OtpVerificationStage = ({
  phoneNumber,
  l2,
  isResendDisabled,
  resendTimer,
  formatTime,
  resendOtp,
  submitOtp,
  onBack,
}) => {
  const classes = useStyles();

  return (
    <StyledBox padding={2}>
      <Box maxWidth={400} margin="auto" mt={2} mb={2}>
        <Button
          onClick={onBack}
          className={classes.back}
          size="small"
          variant="text"
        >
          <ArrowBackIosRoundedIcon />
          &nbsp;Back
        </Button>
        <Typography variant="h3" gutterBottom>
          Verify OTP
        </Typography>
        <Typography variant="body2">
          Please enter the 6-digit verification code sent to you at +91-
          {phoneNumber}
        </Typography>
      </Box>
      <Formik
        initialValues={{ otp: "" }}
        validationSchema={Yup.object().shape({
          otp: Yup.string()
            .matches(/^[0-9]+$/, "OTP must be a number")
            .min(6, "OTP is required")
            .max(6, "OTP is required")
            .required("OTP is required"),
        })}
        onSubmit={(values) => {
          submitOtp(values);
        }}
      >
        {({ errors, touched, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <Box maxWidth={400} margin="auto">
              <Typography variant="h5" gutterBottom className={classes.title}>
                Enter OTP
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <OtpInput
                    handleOtpChange={(otp) => {
                      setFieldValue("otp", otp);
                    }}
                    containerStyles={{ justifyContent: "flex-start" }}
                  />
                  {touched.otp && errors.otp && (
                    <Typography color="error" variant="caption">
                      {errors.otp}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mt={1}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={l2}
                      className={classes.blueGradientBtn}
                    >
                      {l2 ? "Verifying OTP..." : "Submit OTP"}
                    </Button>
                    <Button
                      onClick={resendOtp}
                      color="secondary"
                      disabled={isResendDisabled}
                      variant="text"
                    >
                      {isResendDisabled
                        ? `Resend OTP in ${formatTime(resendTimer)}`
                        : "Resend OTP"}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Form>
        )}
      </Formik>
    </StyledBox>
  );
};

export default OtpVerificationStage;

